import Vue from 'vue';
import Router from 'vue-router';
import pub from './route/pub';
import user from './route/user';

Vue.use(Router)

export default () => {
  return new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
        path: '/p',
        name: 'p',
        component: () =>
          import( /* webpackChunkName: "p" */ './views/pub/layout.vue'),
        children: pub
      },
      {
        path: '/u',
        name: 'u',
        component: () =>
          import( /* webpackChunkName: "u" */ './views/user/layout.vue'),
        children: user
      },
      {
        path: '*',
        redirect: {
          name: 'indexHome'
        }
      }
    ]
  })
}